import { Box, styled } from '@mui/material';
import { GRAY_SECONDARY } from 'constants/colors';
import { formatByLocale, formatHoursMinutes } from 'utils/date';
import { ProjectResponse } from 'generated/index';

const Time = styled(Box)`
  font-family: SourceSansPro-Regular;
  font-size: 12px;
`;

type Props = {
  durationInSeconds: number;
  isAbsent?: boolean;
  project?: ProjectResponse;
  start: string;
  isSideDrawer?: boolean;
};

const TimeSection = ({
  durationInSeconds,
  isAbsent,
  project,
  isSideDrawer = false,
  start
}: Props) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      gap="4px"
      sx={{
        boxSizing: 'border-box',
        width: '80px',
        padding: isSideDrawer ? '0' : '6px 0 4px 8px'
      }}
    >
      {project && (
        <Time
          sx={{
            lineHeight: 1,
            textDecoration: isAbsent ? 'line-through' : 'none',
            paddingTop: '5px',
            paddingBottom: '3px'
          }}
        >
          {durationInSeconds && formatHoursMinutes(durationInSeconds)}
        </Time>
      )}
      {!project && (
        <>
          <Time
            sx={{
              lineHeight: 0,
              textDecoration: isAbsent ? 'line-through' : 'none'
            }}
          >
            {start && formatByLocale(new Date(start), 'HH:mm')}
          </Time>
          <Time
            sx={{
              color: `${GRAY_SECONDARY}`,
              lineHeight: isSideDrawer ? 1 : 'normal',
              textDecoration: isAbsent ? 'line-through' : 'none'
            }}
          >
            {formatHoursMinutes(durationInSeconds)}
          </Time>
        </>
      )}
    </Box>
  );
};

export default TimeSection;
